import Vue from 'vue'
import VueRouter from 'vue-router'
import store from "../store";
import axios from "axios";

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.VUE_BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('@/views/Home.vue'),
      meta: {
        requiresAuth: true,
        pageTitle: 'Home',
        breadcrumb: [
          {
            text: 'Home',
            active: true,
          },
        ],
      },
    },
    {
      path: '/users',
      name: 'users',
      component: () => import('@/views/Users/ListUser.vue'),
      meta: {
        requiresAuth: true,
        pageTitle: 'Users',
        breadcrumb: [
          {
            text: 'Users',
            active: true,
          },
        ],
      },
    },
    {
      path: '/unit-kerja',
      name: 'unit-kerja',
      component: () => import('@/views/UnitKerja/UnitKerja'),
      meta: {
        resource: 'manage',
        action: 'read',
        requiresAuth: true,
        pageTitle: 'Unit Kerja',
        breadcrumb: [
          {
            text: 'Unit Kerja',
            active: true,
          },
        ],
      },
    },
    {
      path: '/profil',
      name: 'profil',
      component: () => import('@/views/Client/Profile/Profil'),
      meta: {
        requiresAuth: true,
        pageTitle: 'Profil',
        breadcrumb: [
          {
            text: 'Profil',
            active: true,
          },
        ],
      },
    },
    {
      path: '/pengawas',
      name: 'pengawas',
      component: () => import('@/views/Pengawas/Pengawas'),
      meta: {
        requiresAuth: true,
        pageTitle: 'Pengawas',
        breadcrumb: [
          {
            text: 'Pengawas',
            active: true,
          },
        ],
      },
    },
    {
      path: '/pengawas/detail/:id',
      name: 'pengawas-detail',
      component: () => import('@/views/Pengawas/Details/Detail'),
      meta: {
        requiresAuth: true,
        pageTitle: 'Pengawas',
        breadcrumb: [
          {
            text: 'Pengawas',
            to : '/pengawas',
          },
          {
            text: 'Detail Pengawas',
            active: true
          }
        ],
      },
    },
    {
      path: '/pengawas/edit/:id',
      name: 'pengawas-edit',
      component: () => import('@/views/Pengawas/Edit/Edit'),
      meta: {
        requiresAuth: true,
        pageTitle: 'Pengawas',
        breadcrumb: [
          {
            text: 'Pengawas',
            to : '/pengawas',
          },
          {
            text: 'Detail Pengawas',
            active: true
          }
        ],
      },
    },
    {
      path: '/pegawai/detail/:id',
      name: 'pegawai-detail',
      component: () => import('@/views/Pegawai/Details/Detail'),
      meta: {
        requiresAuth: true,
        pageTitle: 'Pegawai',
        breadcrumb: [
          {
            text: 'Pegawai',
            to : 'pegawai',
          },
          {
            text: 'Detail Pegawai',
            active: true
          }
        ],
      },
    },
    {
      path: '/pegawai',
      name: 'pegawai',
      component: () => import('@/views/Pegawai/Pegawai'),
      meta: {
        requiresAuth: true,
        pageTitle: 'Pegawai',
        breadcrumb: [
          {
            text: 'Pegawai',
            active: true,
          },
        ],
      },
    },
    {
      path: '/pegawai/edit/:id',
      name: 'pegawai-edit',
      component: () => import('@/views/Pegawai/Edit/Edit'),
      meta: {
        requiresAuth: true,
        pageTitle: 'Pegawai',
        breadcrumb: [
          {
            text: 'Pegawai',
            to : '/pegawai',
          },
          {
            text: 'Detail Pegawai',
            active: true
          }
        ],
      },
    },
    {
      path: '/presensi',
      name: 'presensi',
      component: () => import('@/views/Presensi'),
      meta: {
        requiresAuth: true,
        pageTitle: 'Presensi',
        breadcrumb: [
          {
            text: 'Presensi',
            active: true,
          },
        ],
      },
    },
    {
      path: '/pengumuman',
      name: 'pengumuman',
      component: () => import('@/views/Pengumuman/Pengumuman'),
      meta: {
        requiresAuth: true,
        pageTitle: 'Pengumuman',
        breadcrumb: [
          {
            text: 'Pengumuman',
            active: true,
          },
        ],
      },
    },
    {
      path: '/pegawai/task',
      name: 'pegawai-task',
      component: () => import('@/views/Client/Task/Task'),
      meta: {
        requiresAuth: true,
        pageTitle: 'Task',
        breadcrumb: [
          {
            text: 'Task',
            active: true,
          },
        ],
      },
    },
    {
      path: '/pegawai/report',
      name: 'pegawai-report',
      component: () => import('@/views/Client/Report/Report'),
      meta: {
        requiresAuth: true,
        pageTitle: 'Report',
        breadcrumb: [
          {
            text: 'Report',
            active: true,
          },
        ],
      },
    },
    {
      path: '/bidang',
      name: 'bidang',
      component: () => import('@/views/Bidang/Bidang'),
      meta: {
        requiresAuth: true,
        pageTitle: 'Bidang',
        breadcrumb: [
          {
            text: 'Bidang',
            active: true,
          },
        ],
      },
    },
    {
      path: '/setting',
      name: 'setting',
      component: () => import('@/views/PresensiSetting/PresensiSetting'),
      meta: {
        requiresAuth: true,
        pageTitle: 'Presensi Setting',
        breadcrumb: [
          {
            text: 'Presensi Setting',
            active: true,
          },
        ],
      },
    },
    {
      path: '/kalender',
      name: 'calendar',
      component: () => import('@/views/Calendar/Calendar'),
      meta: {
        requiresAuth: true,
        pageTitle: 'Setting Kalender',
        breadcrumb: [
          {
            text: "Setting Kalendar",
            active: true,
          },
        ],
      },
    },
    {
      path: '/report',
      name: 'report',
      component: () => import('@/views/Report/Report'),
      meta: {
        requiresAuth: true,
        pageTitle: 'Report',
        breadcrumb: [
          {
            text: "Report",
            active: true,
          },
        ],
      },
    },
    {
      path: '/pengajuan',
      name: 'pengajuan',
      component: () => import('@/views/Client/Pengajuan/Pengajuan'),
      meta: {
        requiresAuth: true,
        pageTitle: 'Pengajuan',
        breadcrumb: [
          {
            text: "Pengajuan",
            active: true,
          },
        ],
      },
    },
    {
      path: '/approval',
      name: 'approval',
      component: () => import('@/views/Approval/Approval'),
      meta: {
        requiresAuth: true,
        pageTitle: 'Approval',
        breadcrumb: [
          {
            text: "Approval",
            active: true,
          },
        ],
      },
    },
    {
      path: '/pegawai/presensi/:tanggal',
      name: 'presensi-sistem',
      component: () => import('@/views/PresensiSistem/PresensiSistem'),
      meta: {
        requiresAuth: true,
        pageTitle: 'Presensi Sistem',
        breadcrumb: [
          {
            text: "Presensi Sistem",
            active: true,
          },
        ],
      },
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/Login.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '/error-404',
      name: 'error-404',
      component: () => import('@/views/error/Error404.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '*',
      redirect: 'error-404',
    },
  ],
})

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

router.beforeEach(async (to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters.isAuthenticated) {
      await axios.get('/api/auth/user').then(response => {
        return next()
      }).catch(error => {
        console.log('Token Not Available')
        return next('/login')
      })
    }else{
      return next('/login')
    }
  } else {
    return next()
  }
})

export default router
